/* RESPONSIBLE TEAM: team-frontend-tech */

const EDITABLE_HTML_TAGS = ['input', 'textarea'];

export function isElementEditable(element?: EventTarget | null) {
  if (!element) {
    return false;
  }

  if (!(element instanceof Element)) {
    return false;
  }

  let isEditableTag = EDITABLE_HTML_TAGS.includes(element.tagName?.toLowerCase?.());
  let hasContentEditable =
    element.hasAttribute?.('contentEditable') &&
    element.getAttribute?.('contenteditable')?.toLowerCase() !== 'false';

  return isEditableTag || hasContentEditable;
}

export function isEventTargetEditable(event: Event) {
  // If the target is is inside an shadow root, the `event.target` will return the element that the shadow root is attached to, instead of the element that the event is triggered on.

  // When the event is fired from inside an element in React, a react `synthetic event` instance is sent instead of a native `Event`, hence the need to check for the `originalEvent` property.
  // read more about it here: https://react.dev/reference/react-dom/events/Event#event-composedpath
  let composedPath = event?.composedPath?.() || (event as $TSFixMe)?.originalEvent?.composedPath();

  if (composedPath) {
    return composedPath.some((element) => isElementEditable(element));
  }

  return isElementEditable(event.target);
}
